/**
 * O modo **leitura para agente**: a mesma rota, sem nada além do texto.
 *
 * `/ajustes/agente` é um formulário para gente. Com `#agentInstructions` ela
 * vira a página que um agente lê — só o markdown, sem cabeçalho, sem cartões e
 * sem a barra de abas.
 *
 * ## Por que a marca é o hash, e o que isso custa
 *
 * Foi a URL pedida, e ela tem uma vantagem real: é a mesma rota, então o link
 * continua funcionando com a sessão que já está aberta no navegador.
 *
 * **O custo é que hash não chega ao servidor.** `curl` nesta URL devolve o HTML
 * do SPA, não o markdown — o fragmento nunca sai do navegador. Isto serve para
 * um agente que **dirige um navegador** com a sessão da casa; um agente que só
 * faz `fetch` precisaria de um endpoint de verdade, com token, servindo
 * `text/markdown`. Está dito em `Contexto de agente.md`.
 */
export const HASH_LEITURA = 'agentInstructions'

/** Aceita com e sem `#` — o router entrega de um jeito, o `location` de outro. */
export function isLeituraDeAgente(hash: string): boolean {
  return hash.replace(/^#/, '') === HASH_LEITURA
}
